import { create } from 'zustand';
import { getDeviceType, getOrientation, DeviceType, Orientation } from '../utils/deviceDetection';

interface MobileState {
  deviceType: DeviceType;
  orientation: Orientation;
  isMobile: boolean;
  isQuickCreateOpen: boolean;
  setDeviceType: (type: DeviceType) => void;
  setOrientation: (orientation: Orientation) => void;
  updateDeviceInfo: () => void;
  setQuickCreateOpen: (open: boolean) => void;
}

export const useMobileStore = create<MobileState>((set) => {
  // Initialize device info
  const updateDeviceInfo = () => {
    if (typeof window === 'undefined') return;
    const deviceType = getDeviceType();
    const orientation = getOrientation();
    set({
      deviceType,
      orientation,
      isMobile: deviceType === 'mobile',
    });
  };

  return {
    deviceType: typeof window !== 'undefined' ? getDeviceType() : 'desktop',
    orientation: typeof window !== 'undefined' ? getOrientation() : 'portrait',
    isMobile: typeof window !== 'undefined' ? getDeviceType() === 'mobile' : false,
    isQuickCreateOpen: false,
    setDeviceType: (type: DeviceType) => set({ deviceType: type, isMobile: type === 'mobile' }),
    setOrientation: (orientation: Orientation) => set({ orientation }),
    updateDeviceInfo,
    setQuickCreateOpen: (open: boolean) => set({ isQuickCreateOpen: open }),
  };
});
